<h1 mat-dialog-title>{{message}}</h1>
<mat-dialog-content cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<p>
		{{description}}
	</p>
</mat-dialog-content>
<div *ngIf ="data.buttonText" class="button-align" >
  <button mat-icon-button (click)="onCancel()" ><mat-icon>cancel</mat-icon></button>
  <button mat-icon-button (click)="onConfirmClick()"  ><mat-icon>check</mat-icon></button>
</div>

<div *ngIf ="!data.buttonText" class="button-align" >
  <button mat-icon-button (click)="onCancel()" ><mat-icon>{{'CONFIRMATION.CANCEL_' | translate}}</mat-icon></button>
</div>
